import classNames from 'classnames';
import './styles.scss';

type WidgetTitleProps = {
  title?: React.ReactNode;
  className?: string;
};

const WidgetTitle: React.FC<WidgetTitleProps> = ({ title, className }) => (
  <div className={classNames('widget-title-container', 'drag-area', className)}>{title}</div>
);

export default WidgetTitle;
